import React from 'react';
import {
	Link,
	MainNavigation,
	MainNavigationItem,
	SubNavigation,
	SubNavigationContent,
	SubNavigationHeader,
	SubNavigationItem,
	SubNavigationList,
	SubNavigationTitle,
	User,
} from '@wfp/ui';

import { useDedobCss, useDedobUser } from '../../hooks/home';
import { signOut } from '../../restapi/msal';


export function PageHeader() {
	const user = useDedobUser();
	const cssData = useDedobCss();

	return (<>
		{cssData ? <style>{cssData.css}</style> : null}
		<MainNavigation logo="OIMS">
			<MainNavigationItem>
				<Link href="/">DOB</Link>
			</MainNavigationItem>
			<MainNavigationItem>
				<Link href="https://wl.oims.wfp.org/">EW</Link>
			</MainNavigationItem>
			<MainNavigationItem>
				<Link href="https://wob.oims.wfp.org/">WOB</Link>
			</MainNavigationItem>
			<MainNavigationItem
				className="wfp--main-navigation__user"
				subNavigation={
					<SubNavigation>
						<SubNavigationHeader>
							<SubNavigationTitle>Welcome to OIMS</SubNavigationTitle>
						</SubNavigationHeader>
						<SubNavigationContent>
							<SubNavigationList>
								<SubNavigationItem>
									<a href="#logout" className="wfp--link" onClick={() => signOut()}>Logout</a>
								</SubNavigationItem>
							</SubNavigationList>
						</SubNavigationContent>
					</SubNavigation>
				}>
				<User
					ellipsis
					name={user?.username || user?.email || '...'}
					missingImage="letter"
				/>
			</MainNavigationItem>
		</MainNavigation>
	</>);
}